<template>
  <div id="managePreparencePopup">
    <div id="body" class="col-sm-12 col-xs-12">
      <div class="row">
        <div class="col-md-12">
          <!-- <el-tabs v-model="activeName" class="elTabs"> -->
          <!-- <el-tab-pane label="Registration Tracker" name="first"> -->
          <div class="nav nav-tabs mt-5" role="tablist">
            <div role="presentation" class="nav-item" :class="{ active: activeName == 'first' }">
              <span class="nav-link" role="tab" data-toggle="tab">Registration Tracker</span>
              <div class="col-md-12 col-xs-12 col-sm-12 mb-5 mt-30">
                <div class="row">
                  <div class="col-md-4 col-sm-4 col-xs-12 xs-pd-lt-0">
                    <span class="heading">Display Expiration Date</span>
                  </div>
                  <div class="col-md-4 col-sm-5 col-xs-12 custom-dropdown xs-pd-lt-0">
                    <multiselect
                      :showLabels="false"
                      :close-on-select="true"
                      :allow-empty="false"
                      class="multiselect-single-dropdown"
                      open-direction="bottom"
                      :searchable="false"
                      :options="options.map((option) => option.value)"
                      :custom-label="(option) => options.find((x) => x.value === option).label"
                      v-model="commonDateFormat"
                      placeholder="Select"
                    >
                    </multiselect>
                  </div>
                </div>
              </div>
              <div class="col-md-12 col-sm-12 col-xs-12 mb-10 xs-pd-0">
                <hr />
              </div>
              <div class="box_wrapper_xs col-md-12 col-sm-12 col-xs-12">
                <div class="row">
                  <div class="col-md-12 col-sm-12 col-xs-12 xs-pd-lt-0">
                    <span class="heading">Expiration Status</span>
                  </div>
                  <div class="col-md-12 col-sm-12 col-xs-12 expiry-status-desc xs-pd-tp-0">
                    <span
                      >Indicate how many months prior to the expiration date you would like a record
                      to change from an Active to Expiring Soon status.</span
                    >
                    <span
                      >If you have opted to receive an Expiring Soon alert via your Notifications
                      setting, the below also determines when that email will be sent.</span
                    >
                  </div>
                  <div class="col-md-12 col-sm-12 col-xs-12">
                    <div class="row member-box-wrapper">
                      <div class="col-md-3 col-sm-3 col-xs-3 pr-0 xs-pd-lt-0">
                        <span class="heading heading-type">Country</span>
                      </div>
                      <div class="col-md-3 col-sm-3 col-xs-3 pr-0 xs-pd-lt-0">
                        <span class="heading heading-type">Record Type</span>
                      </div>
                      <div class="col-md-6 col-xs-6 col-sm-6">
                        <div class="row">
                          <div
                            :class="
                              roleId === 5 || roleId === 7
                                ? 'col-md-4 col-sm-4 col-xs-4'
                                : 'col-md-6 col-sm-6 col-xs-6'
                            "
                            class="pr-0 xs-pd-lt-0"
                          >
                            <span class="heading hideHeading heading-type">
                              Renewal timeframe
                              <el-popover
                                class="hide-xs"
                                placement="bottom-end"
                                trigger="click"
                                @show="infoActive = true"
                                @hide="infoActive = false"
                                width="350"
                              >
                                <div class="preference_popover_txt">
                                  <span
                                    >Changes will apply to new records only. Changes will not apply
                                    to existing records.</span
                                  >
                                </div>
                                <!-- <template #reference> -->
                                <img
                                  class="info-img"
                                  src="/static/images/icons/info_icon.svg"
                                  v-if="!infoActive"
                                  alt="info-icon"
                                  slot="reference"
                                />
                                <img
                                  class="info-img"
                                  src="/static/images/icons/info_icon_active.svg"
                                  v-if="infoActive"
                                  alt="infoactive-icon"
                                  slot="reference"
                                />
                                <!-- </template> -->
                              </el-popover>
                            </span>
                            <span class="mobile-heading">
                              RTF
                              <base-tooltip content="Renewal timeframe" placement="top">
                                <i class="fa fa-info-circle" aria-hidden="true"></i>
                              </base-tooltip>
                            </span>
                          </div>
                          <div
                            v-if="roleId !== 5 && roleId !== 7 && roleId !== 11"
                            class="col-md-6 col-sm-6 col-xs-6 pr-0 xs-pd-lt-0"
                          >
                            <span
                              class="heading hideHeading heading-type"
                              data-toggle="tooltip"
                              data-placement="top"
                              title="Emergo recommended Renewal timeframe"
                            >
                              Emergo recommended Renewal timeframe
                              <el-popover
                                class="hide-xs"
                                placement="bottom-end"
                                trigger="click"
                                @show="infoActiveERTF = true"
                                @hide="infoActiveERTF = false"
                                width="350"
                              >
                                <div class="preference_popover_txt">
                                  <span
                                    >The recommended renewal timeframe are set based on the
                                    experience of Emergo by UL. Timeframes are determined by the
                                    average length of time it takes a manufacturer to prepare,
                                    submit and complete the renewal process.</span
                                  >
                                  <span>
                                    In markets where we generally do not provide extensive
                                    regulatory consulting, the default is set to 12 months prior to
                                    expiration.</span
                                  >
                                  <span>
                                    Changes will apply to new records only. Changes will not apply
                                    to existing records.</span
                                  >
                                </div>
                                <!-- <template #reference> -->
                                <img
                                  class="info-img"
                                  src="/static/images/icons/info_icon.svg"
                                  v-if="!infoActiveERTF"
                                  alt="info-icon"
                                  slot="reference"
                                />
                                <img
                                  class="info-img"
                                  src="/static/images/icons/info_icon_active.svg"
                                  v-if="infoActiveERTF"
                                  alt="infoactive-icon"
                                  slot="reference"
                                />
                                <!-- </template> -->
                              </el-popover>
                            </span>
                            <span class="mobile-heading">
                              ERTF
                              <base-tooltip
                                content="Emergo recommended Renewal timeframe"
                                placement="top"
                              >
                                <i class="fa fa-info-circle" aria-hidden="true"></i>
                              </base-tooltip>
                            </span>
                          </div>
                          <div
                            v-if="roleId === 5 || roleId === 7"
                            class="col-md-4 col-sm-4 col-xs-4 pr-0 xs-pd-lt-0"
                          >
                            <span class="heading hideHeading heading-type"
                              >Earliest Renewal Date</span
                            >
                            <span class="mobile-heading">
                              ERD
                              <base-tooltip content="Earliest Renewal Date" placement="top">
                                <i class="fa fa-info-circle" aria-hidden="true"></i>
                              </base-tooltip>
                            </span>
                          </div>
                          <div
                            v-if="roleId === 5 || roleId === 7"
                            class="col-md-4 col-sm-4 col-xs-4 pr-0 xs-pd-lt-0"
                          >
                            <span class="heading hideHeading heading-type">Renewal deadline</span>
                            <span class="mobile-heading">
                              RD
                              <base-tooltip content="Renewal deadline" placement="top">
                                <i class="fa fa-info-circle" aria-hidden="true"></i>
                              </base-tooltip>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- </el-tab-pane> -->
            </div>
          </div>
          <!-- </el-tabs> -->
        </div>
      </div>
      <div class="col-md-12 col-sm-12 col-xs-12 container1">
        <div class="section">
          <div class="col-md-12 col-sm-12 col-xs-12 scrollable-content content">
            <div
              class="row member-box-wrapper"
              v-for="(row, index) in certificateAlertDataList"
              :key="index"
            >
              <div class="col-md-3 col-sm-3 col-xs-3 pr-0 xs-pd-lt-0">
                <span class="wordbreak alert_text">{{ row.country_name }}</span>
              </div>
              <div class="col-md-3 col-sm-3 col-xs-3">
                <span class="wordbreak alert_text">{{ row.certificate_type }}</span>
              </div>
              <div class="col-md-6 col-xs-6 col-sm-6">
                <div class="row">
                  <div
                    class="col-lg-3 col-md-3 xs-pd-lt-0 lg-pd-rt-10"
                    :class="
                      roleId === 5 || roleId === 7
                        ? 'col-sm-4 col-xs-4 xs-pd-rt-0 '
                        : 'col-sm-3 col-xs-6 xs-pd-rt-10'
                    "
                  >
                    <!-- <span> -->
                    <!-- <input
                        type="number"
                        class="form-control xs-pd-6 input_number"
                        min="0"
                        v-model.number="row.alertBeforeMonths"
                        @change="triggerInput(row.certificate_type_id)"
                        @keyup="triggerInput(row.certificate_type_id)"
                      /> -->
                    <base-input-number
                      class="rtf"
                      v-model.number="row.alertBeforeMonths"
                      :min="0"
                      @change="triggerInput(row.certificate_type_id)"
                      @keyup="triggerInput(row.certificate_type_id)"
                    />
                    <!-- </span> -->
                  </div>
                  <div
                    v-if="roleId == 5 || roleId == 7"
                    class="col-lg-offset-1 col-md-offset-1 col-lg-3 col-md-3 col-sm-4 col-xs-4 xs-pd-rt-0 xs-pd-lt-5 lg-pd-rt-10"
                  >
                    <span>
                      <base-input-number
                        :min="0"
                        v-model.number="row.certificateMinimumRenewalDate"
                        @change="triggerInput(row.certificate_type_id)"
                        @keyup="triggerInput(row.certificate_type_id)"
                      />
                    </span>
                  </div>
                  <div
                    v-if="roleId == 5 || roleId == 7"
                    class="col-lg-offset-1 col-md-offset-1 col-lg-3 col-md-3 col-sm-4 col-xs-4 xs-pd-rt-0 xs-pd-lt-5 lg-pd-rt-10"
                  >
                    <span>
                      <base-input-number
                        :min="0"
                        v-model.number="row.certificateRenewalDeadline"
                        @change="triggerInput(row.certificate_type_id)"
                        @keyup="triggerInput(row.certificate_type_id)"
                      />
                    </span>
                  </div>
                  <div v-else class="col-md-3 col-sm-3 col-xs-4 pl-0 months_bef_wrapper">
                    <span class="alert_text">months before</span>
                  </div>
                  <div v-if="roleId !== 5 && roleId !== 7 && roleId !== 11">
                    <div
                      class="col-lg-3 col-md-3 col-sm-3 col-xs-6 xs-pd-lt-0 xs-pd-rt-10 lg-pd-rt-10"
                    >
                      <span>
                        <input
                          type="text"
                          disabled
                          class="form-control xs-pd-6 input_number"
                          :value="row.emergo_recommended_renewal_timeframe"
                        />
                      </span>
                    </div>
                    <div class="col-md-3 col-sm-3 col-xs-4 pl-0 months_bef_wrapper">
                      <span class="alert_text">months before</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-xs-12 col-sm-12 col-md-12 footer">
      <div class="col-md-2 col-sm-3 col-xs-5 col-md-offset-7 col-sm-offset-5 xs-pd-lt-0">
        <button
          type="button"
          class="btn btn-block emergo-white-button"
          data-dismiss="modal"
          @click="$emit('closepopup')"
        >
          Cancel
        </button>
      </div>
      <div class="col-md-3 col-xs-7 col-sm-4 xs-pd-lt-0 xs-pd-rt-0">
        <button
          type="button"
          class="btn btn-block emergo-green-button"
          @click="saveChanges"
          :disabled="updateSet.length === 0 && commonDateFormat === tempCommonDateFormat"
        >
          Save Changes
        </button>
      </div>
    </div>
    <loader :loadingStatus="loaderStatus"></loader>
  </div>
</template>

<script>
import { Popover } from 'element-ui';
import Loader from '../UIComponents/Loader.vue';
import BaseTooltip from '../Common/BaseTooltip.vue';
// import BasePopover from '../Common/BasePopover.vue';
import BaseInputNumber from '../Common/BaseInputNumber.vue';

import {
  getUserPreference,
  updateUserPreference,
  getUserCertificateAlerts,
  updateUserCertificateAlerts
} from '../../apis/profile';

export default {
  components: {
    Loader,
    BaseTooltip,
    BaseInputNumber,
    // BasePopover,
    'el-popover': Popover
  },
  props: ['roleId'],
  data() {
    return {
      errors: [],
      loaderStatus: false,
      selectedPreferences: [],
      certificateAlertDataList: [],
      counter: 0,
      commonDateFormat: '',
      activeTab: '',
      dropdownSelected: 'preferences',
      activeName: 'first',
      infoActive: false,
      infoActiveERTF: false,
      options: [
        { value: 'Actual date', label: 'Actual date' },
        { value: 'remaining', label: 'Time remaining until expiration date' }
      ],
      updateSet: [],
      tempCommonDateFormat: ''
    };
  },
  computed: {},
  filters: {},
  methods: {
    clearNotifications() {
      this.$notify({
        clear: true,
        group: 'custom-notification'
      });
    },

    async saveChanges() {
      if (this.commonDateFormat !== this.tempCommonDateFormat) {
        this.tempCommonDateFormat = this.commonDateFormat;
        await this.updateDisplayPreference();
      }
      if (Object.keys(this.updateSet).length > 0) {
        await this.updateCertificateAlertTime();
        await this.loadCertificatePreferences();
      }
    },
    async updateDisplayPreference() {
      this.loaderStatus = true;
      const data = {
        expiry_date_format: this.commonDateFormat
      };
      const response = await updateUserPreference(data);
      if (response.status) {
        this.loaderStatus = false;
        this.clearNotifications();
        this.$notify({
          type: 'success',
          title: 'Success',
          text: 'User Preferences updated successfully!',
          group: 'custom-notification'
        });
      } else {
        this.clearNotifications();
        this.$notify({
          type: 'error',
          title: 'Error',
          text: 'User Preferences update failed!',
          group: 'custom-notification'
        });
      }
    },
    async updateCertificateAlertTime() {
      this.loaderStatus = true;
      const response = await updateUserCertificateAlerts(this.updateSet);
      if (response.status) {
        this.clearNotifications();
        this.$notify({
          type: 'success',
          title: 'Success',
          text: 'Alerts updated successfully!',
          group: 'custom-notification'
        });
        this.updateSet = [];
        this.loaderStatus = false;
        await this.loadUserPreferences();
      } else {
        this.clearNotifications();
        this.$notify({
          type: 'error',
          title: 'Error',
          text: 'Updating alerts failed!',
          group: 'custom-notification'
        });
      }
    },
    increment() {
      this.counter += 1;
    },
    decrement() {
      this.counter = 0;
    },
    async loadCertificatePreferences() {
      this.loaderStatus = true;
      const response = await getUserCertificateAlerts();
      const certificateAlertDataList = response.filter((each) => each.country_name !== null);
      this.certificateAlertDataList = certificateAlertDataList.sort((a, b) =>
        a.country_name.localeCompare(b.country_name)
      );
      this.loaderStatus = false;
    },
    async loadUserPreferences() {
      this.loaderStatus = true;
      const response = await getUserPreference();
      if (response) {
        this.commonDateFormat = response.expiry_date_format;
        this.tempCommonDateFormat = response.expiry_date_format;
      }
      this.loaderStatus = false;
    },
    triggerInput(certificateTypeId) {
      const record = this.certificateAlertDataList.filter(
        (data) => data.certificate_type_id === certificateTypeId
      );
      const index = this.updateSet.findIndex(
        (obj) => obj.certificate_type_id === certificateTypeId
      );
      if (index >= 0) {
        this.updateSet = [...this.updateSet.slice(0, index), ...this.updateSet.slice(index + 1)];
      }
      if (Object.keys(record).length > 0) {
        this.updateSet.push({
          alertBeforeMonths: record[0].alertBeforeMonths,
          certificateMinimumRenewalDate: record[0].certificateMinimumRenewalDate,
          certificateRenewalDeadline: record[0].certificateRenewalDeadline,
          certificate_type: record[0].certificate_type,
          certificate_type_id: record[0].certificate_type_id,
          country_name: record[0].country_name,
          isValueSet: record[0].isValueSet
        });
      }
    }
  },
  watch: {
    certificateAlertDataList: {
      deep: true,
      handler() {
        for (let i = 0; i < this.certificateAlertDataList.length; i += 1) {
          if (this.certificateAlertDataList[i].alertBeforeMonths < 1) {
            this.certificateAlertDataList[i].alertBeforeMonths = 0;
          }
          if (this.certificateAlertDataList[i].certificateMinimumRenewalDate < 1) {
            this.certificateAlertDataList[i].certificateMinimumRenewalDate = 0;
          }
          if (this.certificateAlertDataList[i].certificateRenewalDeadline < 1) {
            this.certificateAlertDataList[i].certificateRenewalDeadline = 0;
          }
        }
      }
    },
    country_name() {
      if (
        this.country_name !== '' &&
        this.countryCertificateType[this.country_name] !== undefined
      ) {
        this.certificateTypeList = this.countryCertificateType[this.country_name].split(',');
      } else {
        this.certificateTypeList = [];
        this.certificateTypeName = '';
      }
    }
  },
  async created() {
    await this.loadUserPreferences();
    await this.loadCertificatePreferences();
  },

  mounted() {}
};
</script>
<style lang="scss" scoped>
@mixin navTabProps {
  color: $black;
  cursor: pointer;
  font-weight: bold;
  border: none;
  border-bottom: 1px solid $gray74;
  padding-bottom: 10px;
}
.container1 {
  position: absolute;
  left: 0px;
  right: 0px;
  display: flex;
  flex-direction: column;
  max-height: calc(84vh - 404px);
}
.section {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
}
.scrollable-content {
  flex-grow: 1;
  overflow: auto;
  overflow-x: hidden;
  min-height: 0;
}
.input_number {
  text-align: center;
}
.preference_popover_txt {
  text-align: left;
  word-break: break-word;
}
.alert_text {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
  vertical-align: bottom;
  color: $dark-black-alpha !important;
}
.info-img {
  height: 18px;
  width: 18px;
  margin-left: 6px;
}
.prd-dtls-pd {
  padding: 10px 0px 0px 0px;
}
.header-team {
  padding: 15px 0px 0px 0px;
  font-family: Roboto;
  font-style: normal;
  @include fontItems($font-28, 33px, $font-weight-small);
}
.icon-close {
  color: $deep-gray !important;
}
#managePreparencePopup {
  .v-select {
    .dropdown-toggle {
      background-image: none;
    }
  }
}
.add-border {
  width: 100%;
  border: 0.5px solid $deep-gray;
  box-sizing: border-box;
  border-radius: $radius20;
}
.subHeader {
  font-family: Roboto;
  font-style: normal;
  font-weight: $font-weight-400;
  font-size: $font-20;
  color: $primary;
  margin-top: 10px;
  margin-bottom: 15px;
}
.popup-close {
  float: right;
}
#body {
  margin-bottom: 10px;
}
.member-box-wrapper {
  padding-top: 5px;
  padding-bottom: 5px;
  border-bottom: 0.5px solid $gray74;
}
.expiry-status-desc {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
  color: $dark-black-alpha;
  padding: 15px;
}
.heading {
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  color: $dark-black-alpha;
}
.mb-10 {
  margin-bottom: -10px;
}
.mb-5 {
  margin-bottom: -5px;
}
.wordbreak {
  word-break: break-all;
}
.pd-top-6 {
  padding-top: 6px;
}
::v-deep .elTabs {
  .el-tabs__header {
    margin-bottom: 15px;
  }
  .el-tabs__item {
    font-size: 16px;
  }
  .el-tabs__nav-wrap {
    width: 98%;
  }
}
hr {
  margin-left: -13px;
}
.mobile-heading {
  display: none;
}
.el-select-dropdown__item {
  &.selected {
    color: $primary;
  }
}
.footer {
  padding-top: 10px;
  position: absolute;
  bottom: 0%;
  padding-bottom: 2%;
  right: 0;
  background-color: $white;
}
.nav {
  .nav-item {
    cursor: pointer;
    position: relative;
  }
}
.nav-item {
  &.active {
    &::after {
      position: absolute;
      content: '';
      height: 3px;
      width: 145px;
      border-bottom: 8px solid $light-green;
      background: none;
      left: 0;
      bottom: -5px;
      animation: appear 0.2s linear;
    }
  }
}
.nav-tabs {
  .nav-item {
    &.active {
      @include navTabProps();
      &:focus,
      &:hover {
        @include navTabProps();
      }
    }
  }
}

@media screen and (max-width: 1024px) {
  input[type='number']::-webkit-inner-spin-button,
  input[type='number']::-webkit-outer-spin-button {
    width: 20%;
    pointer-events: auto;
  }
}
@media (device-width: 1366px) and (device-height: 1024px) {
  input[type='number']::-webkit-inner-spin-button,
  input[type='number']::-webkit-outer-spin-button {
    width: 20%;
    pointer-events: auto;
  }
}
@media (min-width: 768px) and (max-width: 991px) {
  .form-control {
    padding: 7px;
  }
}

@media screen and (max-width: 767px) {
  .months_bef_wrapper {
    display: none;
  }
  .custom-dropdown {
    margin-top: 5px;
  }
  .xs-pd-tp-0 {
    padding-top: 0px;
  }
  .expiry-status-desc {
    padding-bottom: 5px;
  }
  .pd-top-6 {
    padding-top: 0px;
  }
  .mobile-heading {
    display: block;
    font-size: 13px;
    font-weight: 500;
  }
  .heading {
    font-size: 13px;
  }
  .hideHeading {
    display: none;
  }
  .xs-pd-0 {
    padding: 0px;
  }
  .xs-pd-lt-5 {
    padding-left: 5px;
  }
  .xs-pd-6 {
    padding: 6px;
  }
  .xs-pd-rt-0 {
    padding-right: 0px;
  }
  .xs-pd-rt-10 {
    padding-right: 10px;
  }
  .xs-pd-lt-0 {
    padding-left: 0px;
  }
  .footer {
    padding-bottom: 5%;
  }
}
@media (min-width: 321px) and (max-width: 767px) {
  .container1 {
    max-height: calc(84vh - 435px);
  }
}
@media screen and (max-width: 1023px) {
  .hide_sm_xs {
    display: none;
  }
}
@media (width: 1024px) and (height: 768px) {
  .container1 {
    max-height: calc(84vh - 550px);
  }
}
@media screen and (width: 768px) {
  .container1 {
    max-height: calc(84vh - 610px);
  }
}
@media (min-width: 769px) and (max-width: 1024px) {
  #body {
    height: 41vh;
    overflow-y: scroll;
  }
}
@media (min-width: 1025px) and (max-width: 1280px) {
  .form-control {
    padding: 0px;
  }
  .mt-5 {
    margin-top: 5px;
  }
  .mt-30 {
    margin-top: 30px;
  }
}
@media only screen and (max-width: 320px) {
  #body {
    height: 60vh;
    overflow-y: scroll;
  }
  .container1 {
    max-height: 100%;
  }
}
/* iphoneX landscape  */
@media (device-width: 812px) and (device-height: 375px) {
  #body {
    height: 46vh;
    overflow-y: scroll;
  }
  .container1 {
    max-height: 100%;
  }
}
/* iphone5 landscape and below */
@media (max-width: 640px) and (max-height: 360px) {
  #body {
    height: 33vh;
    overflow-y: scroll;
  }
  .container1 {
    max-height: 100%;
  }
}
/* iphone 6 and 6+ landscape  */
@media (device-width: 736px) and (device-height: 414px),
  (device-width: 667px) and (device-height: 375px) {
  #body {
    height: 44vh;
    overflow-y: scroll;
  }
  .container1 {
    max-height: 100%;
  }
}
</style>
